import React, { useContext, useState } from "react";
import { withRouter } from "react-router-dom";
import { Header, Button, Message } from "semantic-ui-react";
import UserContext from "contexts/UserContext";
import { API } from "aws-amplify";

const getCustomerPortalUrl = async (user) => {
  const apiName = "KnowMyDayAPI";
  const path = "/customer-portal";

  const attrs = {
    body: {
      customer: user.getAttributes().stripeCustomerId,
    },
  };
  const result = await API.post(apiName, path, attrs);
  window.location.href = result.url;
};

const AccountSettings = withRouter(({ history }) => {
  const user = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);

  let status = "Free";
  if (user.isPro()) {
    status = "Pro";
    if (user.getAttributes().isCustomer !== true) {
      status = "Licensed";
    }
  }

  return (
    <div>
      <Header as="h3">Account</Header>
      <p>
        Your current subscription level: <b>{status}</b>
      </p>
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          setIsLoading(true);
          await getCustomerPortalUrl(user);
        }}
      >
        {status === "Pro" && (
          <>
            <Button loading={isLoading} type="submit" color="teal">
              Manage subscription
            </Button>
          </>
        )}
        {status === "Licensed" && (
          <>
            <Message info>
              <p>Your subscription is managed by another account.</p>
            </Message>
          </>
        )}
        {status === "Free" && (
          <Button
            onClick={() => history.push("/upgrade")}
            type="submit"
            color="teal"
          >
            Upgrade to Pro
          </Button>
        )}
      </form>
    </div>
  );
});

export default AccountSettings;
